import Swiper from 'swiper';
import { Navigation, Pagination, Scrollbar, EffectFade, Autoplay, Mousewheel, Parallax, Controller } from 'swiper/modules';
Swiper.use([Navigation, Pagination, Scrollbar, EffectFade, Autoplay, Mousewheel, Parallax, Controller]);

import SwiperManager from './swiperManager';

$(() => {
  new Swiper('.swiper-fv', {
    loop: true,
    effect: 'fade',
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    speed: 2000,
  })

  new Swiper('.swiper-case', {
    slidesPerView: 'auto',
    loop: true,
    centeredSlides: true,
    spaceBetween: 24,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },  
  })
  
})
